import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import Landing from "Pages/landing/Landing";
import Signup from "Pages/Auth/signup/Host/Signup";
import Login from "Pages/Auth/login/Host/Login";
import SignupCompany from "Pages/Auth/signup/Company/SignupCompany";
import LoginCompany from "Pages/Auth/login/Company/LoginCompany";
import Host from "Pages/dashboard/host/Host";
import Welcome from "Pages/dashboard/host/Welcome";
import ApprovalWait from "components/Forms/Multistep/ApprovalWait";
import MyMeetings from "Pages/dashboard/host/Meetings/MyMeetings";
import MyShowrooms from "Pages/dashboard/host/Showrooms/MyShowrooms";
import UserSettings from "Pages/dashboard/host/Settings/UserSettings";
import LoyaltyCard from "components/Forms/MurphyCard/LoyaltyCard";
// import history from "utils/history";
import { createBrowserHistory } from "history";
import ProductAddition from "Pages/dashboard/host/Showrooms/ProductAddition";
import ViewHost from "Pages/dashboard/store/Hosts/ViewHost";
import Recordings from "Pages/dashboard/store/Recordings/Recordings";
import ForgotPassword from "Pages/Auth/Password/ForgotPassword";
import ResetPassword from "Pages/Auth/Password/ResetPassword";
import RequestAccountDeletion from "Pages/Auth/AccountDeletion/RequestAccountDeletion";
import AccountDeletionVerification from "Pages/Auth/AccountDeletion/AccountDeletionVerification";
import UserInformation from "Pages/dashboard/Profile/UserInformation";
import ChangePassword from "Pages/Auth/Password/ChangePassword";
// import PushNotification from "../components/Notification/push-notification";
import SignupVerify from "Pages/Auth/signup/SignupVerify";
import VideoMeeting from "../Pages/videoChat/Video-meeting";
import WaitingRoom from "../Pages/videoChat/WaitingRoom";
import Payouts from "Pages/dashboard/host/MurphyCard/Payouts";
import Sidebaar from "layout/Sidebaar";
import Headerss from "layout/Headers";
import PaymentPurebrand from "Pages/dashboard/PureBrand/Payments/PaymentPurebrand";
import RecordMeetings from "../Pages/Recordings/RecordMeetings";
import PurebrandAdminRoute from "./PurebrandAdminRoute";
import RequireCapability from "./RequireCapability";
import { CAPABILITIES } from "utils/capabilities";
import UserRoute from "./UserRoute";
import NotificationPage from "Pages/Notification/Notification";
import {
  PrivacyPolicyPB,
  TermsAndConditionsPB,
} from "components/Agreements/LegalAgreements";
import AdminHostPage from "Pages/dashboard/PureBrand/Hosts/AdminHostPage";
import Companies from "Pages/dashboard/PureBrand/Companies/Companies";
import ReviewPageAdmin from "Pages/dashboard/PureBrand/Companies/ReviewPageAdmin";
import StoreBills from "Pages/dashboard/store/Billings/StoreBills";
import ContactSupport from "Pages/Support/ContactSupport";
import Checkout from "Pages/Payments/Checkout";
import MeetingStoreView from "Pages/dashboard/store/Payments/MeetingStoreView";
import MeetingHostView from "Pages/dashboard/host/Payments/MeetingHostView";
import ShowroomEdit from "Pages/dashboard/host/Showrooms/ShowroomEdit";
import Meetings from "Pages/dashboard/host/Meetings/Meetings";
import NotFound from "Pages/Error/NotFound";
import ProfilePublic from "Pages/PublicUser/ProfilePublic";
import HostProfilePublic from "Pages/PublicUser/HostProfilePublic";
import SoftReview from "Pages/PublicUser/SoftReview";
import SeeReview from "Pages/PublicUser/SeeReview";
import MeetingStatusPublic from "Pages/PublicUser/MeetingStatusPublic";
import QuickSignup from "Pages/PublicUser/QuickSignup";
import FirstTimeChange from "Pages/Auth/Password/FirstTimeChange";
import StoreDemos from "Pages/dashboard/store/Demos/StoreDemos";
import ShopifyDetails from "Pages/dashboard/store/ShopifyStoreDetails/ShopifyDetails";
import HostRecruitment from "Pages/dashboard/store/HostRecruitment/HostRecruitment";
import EmailEditorComparison from "Pages/dashboard/store/EmailEditorComparison/EmailEditorComparison";
import GrapesJsEditor from "Pages/dashboard/store/EmailEditorComparison/GrapesJsEditor";
// import StripeComplete from "Pages/StripeComplete";
import ProductListView from "Pages/dashboard/store/ProductLists/ProductListView";
import AddRole from "Pages/dashboard/store/RolesForm/AddRole";
import AdminOnboard from "Pages/Auth/signup/AdminOnboard";
import Subscription from "Pages/dashboard/store/Subscription/Subscription";
import LiveMeeting from "Pages/PublicUser/LiveMeeting";
import Business from "Pages/Business/Business";
import MeetingTakeaways from "Pages/MeetingTakeaways/MeetingTakeaways";
import TestMeetingGenerator from "Pages/test/TestMeetingGenerator";
import TestMeetingRoom from "Pages/test/TestMeetingRoom";
import CommissionCalculator from "components/Dots/CommissionCalculator";
import FlowSelection from "Pages/dashboard/store/Flow/FlowSelection";
import CommunicationFlowBuilder from "Pages/dashboard/store/Flow/CommunicationFlowBuilder";
import BadgeAnalytics from "Pages/dashboard/store/BadgeAnalytics/BadgeAnalytics";

const CustomRouter = () => {
  const history = createBrowserHistory();
  return (
    <BrowserRouter history={history}>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route element={<SeeReview />} path="/view" />
        <Route path="/" element={<Headerss />}>
          {/* <Route element={<Landing />} path="/" exact />
          <Route element={<Business />} path="/business" />  */}
          <Route element={<Login />} path="/" exact/>
          <Route element={<Login />} path="/login" />
          <Route element={<ForgotPassword />} path="/forgot-password" />
          <Route
            element={<RequestAccountDeletion />}
            path="/request-account-deletion"
          />
          <Route
            element={<AccountDeletionVerification />}
            path="/account-deletion"
          />
          <Route
            element={<ResetPassword />}
            path="/reset-password/:uid/:token/"
          />
          <Route
            element={<AdminOnboard />}
            path="/on-boarding-complete/:uid/:token/"
          />
          <Route
            element={<MeetingStatusPublic />}
            path="/meeting-status-check"
          />
          <Route element={<Signup />} path="/signup" />
          <Route element={<SignupVerify />} path="/verify-account/:uid/" />
          <Route element={<SignupCompany />} path="/store-signup" />
          <Route element={<LoginCompany />} path="/store-login" />
          <Route element={<PrivacyPolicyPB />} path="/privacy-policy" />
          <Route
            element={<TermsAndConditionsPB />}
            path="/terms-and-conditions"
          />
          <Route element={<ContactSupport />} path="/support" />
          <Route element={<ProfilePublic />} path="/demo/:uid/" />
          <Route element={<HostProfilePublic />} path="/host/:uid/" />
          <Route element={<SoftReview />} path="/review" />
          <Route element={<QuickSignup />} path="/join" />
        </Route>
        <Route
          path="/user"
          element={
            <PrivateRoute>
              <Sidebaar />
            </PrivateRoute>
          }
        >
          <Route
            element={
              <PurebrandAdminRoute>
                <RecordMeetings />
              </PurebrandAdminRoute>
            }
            path="/user/recordings"
          />
          <Route
            element={
              <PurebrandAdminRoute>
                <PaymentPurebrand />
              </PurebrandAdminRoute>
            }
            path="/user/payments"
          />
          <Route
            element={
              <PurebrandAdminRoute>
                <AdminHostPage />
              </PurebrandAdminRoute>
            }
            path="/user/store-hosts"
          />
          <Route
            element={
              <PurebrandAdminRoute>
                <ReviewPageAdmin />
              </PurebrandAdminRoute>
            }
            path="/user/review"
          />
          <Route
            element={
              <RequireCapability capability={CAPABILITIES.ACCOUNTING_VIEW}>
                <StoreBills />
              </RequireCapability>
            }
            path="/user/accounting"
          />

          {/* TODO: Uncomment this once the investigation of soft reviews and code snippets feature is completed */}
          
          {/* <Route
            element={
              <PurebrandAdminRoute>
                <SoftReviewAdmin />
              </PurebrandAdminRoute>
            }
            path="/user/soft-reviews"
          /> */}
          {/* <Route
            element={
              <PurebrandAdminRoute>
                <CodeSnippetAdmin />
              </PurebrandAdminRoute>
            }
            path="/user/codeSnippet"
          /> */}
          <Route
            element={
              <RequireCapability capability={CAPABILITIES.PRODUCTS_VIEW}>
                <ProductListView />
              </RequireCapability>
            }
            path="/user/productsList"
          />
          <Route
            element={
              <RequireCapability capability={CAPABILITIES.TAKEAWAYS_VIEW}>
                <MeetingTakeaways />
              </RequireCapability>
            }
            path="/user/meeting-takeaways"
          />
          <Route
            element={
              <RequireCapability capability={CAPABILITIES.HOSTS_VIEW}>
                <HostRecruitment />
              </RequireCapability>
            }
            path="/user/HostRecruitment"
          />
          <Route
            element={
              <RequireCapability capability={CAPABILITIES.COMMUNICATIONS_VIEW}>
                <FlowSelection />
              </RequireCapability>
            }
            path="/user/flow"
          />
          <Route
            element={
              <RequireCapability capability={CAPABILITIES.COMMUNICATIONS_VIEW}>
                <CommunicationFlowBuilder />
              </RequireCapability>
            }
            path="/user/flow/builder"
          />

          <Route
            element={
              <RequireCapability capability={CAPABILITIES.COMMUNICATIONS_VIEW}>
                <EmailEditorComparison />
              </RequireCapability>
            }
            path="/user/unlayer-editor"
          />
          <Route
            element={
              <RequireCapability capability={CAPABILITIES.COMMUNICATIONS_VIEW}>
                <GrapesJsEditor />
              </RequireCapability>
            }
            path="/user/grapesjs-editor"
          />
          <Route
            element={
              <RequireCapability capability={CAPABILITIES.SHOPIFY_VIEW}>
                <ShopifyDetails />
              </RequireCapability>
            }
            path="/user/shopifyDetails"
          />
          <Route
            element={
              <PurebrandAdminRoute>
                <Companies />
              </PurebrandAdminRoute>
            }
            path="/user/companies"
          />
          <Route
            element={
              <RequireCapability capability={CAPABILITIES.HOSTS_VIEW}>
                <ViewHost />
              </RequireCapability>
            }
            path="/user/host"
          />
          {/* <Route
            element={
              <RequireCapability capability={CAPABILITIES.MEETINGS_VIEW}>
                <MeetingStoreView />
              </RequireCapability>
            }
            path="/user/payment-store"
          /> */}
          <Route
            element={
              <RequireCapability capability={CAPABILITIES.ACCOUNTING_MANAGE}>
                <Checkout />
              </RequireCapability>
            }
            path="/user/checkout"
          />
          <Route
            element={
              <RequireCapability capability={CAPABILITIES.MEETINGS_VIEW}>
                <StoreDemos />
              </RequireCapability>
            }
            path="/user/store-meetings"
          />
          <Route element={<Welcome />} path="/user/welcome" />
          <Route element={<Host />} path="/user/completeprofile" />
          <Route
            element={
              <UserRoute>
                <ApprovalWait />
              </UserRoute>
            }
            path="/user/meeting-status"
          />
          <Route
            element={
              <UserRoute>
                <Meetings />
              </UserRoute>
            }
            path="/user/meetings"
          />
          <Route
            element={
              <UserRoute>
                <MyShowrooms />
              </UserRoute>
            }
            path="/user/showrooms"
          />

          <Route
            element={
              <RequireCapability capability={CAPABILITIES.TEAM_MANAGE}>
                <AddRole />
              </RequireCapability>
            }
            path="/user/addRole"
          />
          <Route element={<UserSettings />} path="/user/settings" />
          <Route
            element={
              <RequireCapability capability={CAPABILITIES.SUBSCRIPTION_VIEW}>
                <Subscription />
              </RequireCapability>
            }
            path="/user/subscription"
          />
          <Route
            element={
              <RequireCapability capability={CAPABILITIES.BADGE_VIEW}>
                <BadgeAnalytics />
              </RequireCapability>
            }
            path="/user/badge-analytics"
          />
          <Route element={<LoyaltyCard />} path="/user/apply-loyalty" />
          <Route
            element={
              <UserRoute>
                <Payouts />
              </UserRoute>
            }
            path="/user/my-accounting"
          />
          <Route
            element={
              <UserRoute>
                <MeetingHostView />
              </UserRoute>
            }
            path="/user/my-meeting-history"
          />
          <Route
            element={
              <UserRoute>
                <ProductAddition />
              </UserRoute>
            }
            path="/user/addproduct"
          />
          <Route
            element={
              <UserRoute>
                <ShowroomEdit />
              </UserRoute>
            }
            path="/user/editproduct/:uid/"
          />
          <Route element={<NotificationPage />} path="/user/notifications" />
          <Route element={<UserInformation />} path="/user/profile" />
          <Route element={<ChangePassword />} path="/user/change-password" />
          <Route element={<FirstTimeChange />} path="/user/set-password" />
        </Route>
        <Route path="/demo" element={<Headerss />}>
          {/* <Route element={<WaitingRoom />} path="/demo/waiting-room" /> */}
          <Route element={<WaitingRoom />} path="/demo/waiting-room/:demoId" />
          <Route element={<VideoMeeting />} exact path="/demo/room/:userName" />
        </Route>
        <Route element={<LiveMeeting />} path="/live-meeting/:demoId" />
        {/* Test Meeting Routes - No authentication required */}
        <Route element={<TestMeetingGenerator />} path="/test-meeting-generator" />
        <Route element={<TestMeetingRoom />} path="/test-meeting" />
        <Route element={<CommissionCalculator />} path="/commission-calculator" />
        {/* {user && loggedIn && (
          <>
            <Route element={<StripeComplete />} path={`/stripe-complete/*`} />
          </>
        )} */}
      </Routes>
    </BrowserRouter>
  );
};

export default CustomRouter;
